import { CustomCellEditorProps } from "ag-grid-react";
import { memo } from "react";
import { BudgetItem, BudgetUnit, unitsValues } from "../types";
import { budgetGridCellSelectClass } from "../BudgetGridCommon";

export default memo(
  (
    params: CustomCellEditorProps & {
      updateBudgetItem: (
        budgetItemId: number,
        update_data: Partial<BudgetItem>,
        previous_data: Partial<BudgetItem>
      ) => void;
    }
  ) => {
    const onValueChange = (value: BudgetUnit) => {
      const previous_data = { unit: params.data.unit };
      params.data.unit = value;
      params.updateBudgetItem(params.data.budget_item_id, { unit: value }, previous_data);
      params.stopEditing();
    };

    return (
      <select
        id="units"
        className={budgetGridCellSelectClass}
        value={params.value ?? ""}
        onChange={(e) => onValueChange(e.target.value as BudgetUnit)}
        autoFocus
      >
        <option value="" disabled hidden />
        {unitsValues.map((unit) => (
          <option key={unit.value} value={unit.value}>
            {unit.label}
          </option>
        ))}
      </select>
    );
  }
);
